<template>
  <div class="c-document">
    <QueryForm ref="queryFormRef" @query="onQueryAction">
      <template #parent="{ formData }" v-if="pageType.imageStyle">
        <ElFormItem label="一级素材样式">
          <el-select v-model="formData.labelId" @change="onQueryAction" filterable clearable placeholder="全部">
            <el-option v-for="item in materialStyles" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="标签层级" v-if="viewType.table">
          <el-select v-model="formData.level" style="width: 80px" @change="onQueryAction" filterable clearable placeholder="全部">
            <el-option v-for="level in 2" :key="level" :label="level + '级'" :value="level"> </el-option>
          </el-select>
        </ElFormItem>
      </template>

      <div style="display: flex; align-items: center">
        <template v-if="pageType.contentTag">
          <el-button @click="onBatchModify(selectionList)">批量修改</el-button>
        </template>
        <template v-else>
          <el-button @click="onBatchModify(selectionList)">批量修改游戏</el-button>
        </template>
        <el-button @click="onShowAddTagModal" type="primary">新增{{ tagType.label }}</el-button>

        <template v-if="pageType.imageStyle">
          <div style="margin-left: 4px; display: inline-flex; align-items: center">
            <LevelToggleBtn :view-type="viewType" @toggle="toggleViewType"></LevelToggleBtn>
          </div>
        </template>
      </div>
    </QueryForm>

    <!-- table -->
    <Viewport ref="viewPortRef" v-model="tableHeight">
      <div v-if="viewType.tree">
        <el-table
          v-loading="tableLoading"
          :data="tagTreeData"
          :height="tableHeight"
          ref="tagTreeTableRef"
          class="common-el-table-styles"
          default-expand-all
          row-key="labelId"
          border
        >
          <el-table-column prop="content" label="素材样式" width="280" show-overflow-tooltip>
            <template slot="header">
              <span>素材样式&emsp;</span>
              <el-button type="text" @click="onToggleRowExpansion(true)">展开全部</el-button>
              <el-button type="text" @click="onToggleRowExpansion(false)">收起全部</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="labelId" label="标签ID" width="80"> </el-table-column>
          <el-table-column prop="gameNames" label="关联游戏" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="createOpName" label="创建人" width="120"> </el-table-column>
          <el-table-column prop="upOpName" label="更新人" width="120"> </el-table-column>
          <el-table-column prop="createTimeText" label="创建时间" width="140"> </el-table-column>
          <el-table-column prop="upTimeText" label="最后修改时间" width="140"> </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onTableRowUpdate(row)">修改</el-button>
              <el-button type="text" @click="onTableRowRemove(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <template v-else>
        <tag-table
          v-loading="tableLoading"
          :data="tableData"
          :columns="pageType.imageStyle ? imageStyleCols : defaultCols"
          :height="tableHeight"
          @edit="onTableRowUpdate"
          @del="onTableRowRemove"
          @select="onTableSelectionChange"
        >
          <template #selection v-if="pageType.imageStyle">
            <el-table-column type="selection" width="39" :selectable="(row) => row.level === LEVEL_TYPES.LEVEL_TWO"> </el-table-column>
          </template>

          <template #content="{ row }">
            <el-button type="text" @click="toMaterialPageList(row)">{{ row.content }}</el-button>
          </template>

          <template #related-materials="{ row }">
            <el-button type="text" @click="getRelated(row)"> {{ row.relatedMaterialsNum }} </el-button>
          </template>
        </tag-table>

        <el-pagination
          class="c-table-page pager"
          background
          :current-page.sync="pager.pageId"
          :page-sizes="[10, 20, 30, 40, 100]"
          :page-size.sync="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
          @size-change="onQueryAction"
          @current-change="getTableData"
        />
      </template>
    </Viewport>

    <!-- 弹出框 -->
    <el-dialog :visible.sync="showTagFormModal" :title="modalTitle" width="620px" :close-on-click-modal="false" @closed="onCloseModal">
      <MaterialStyleForm v-if="pageType.imageStyle" ref="tagFormRef" :form-type="modalType">
        <template #parent="{ formData }">
          <ElFormItem label="一级素材样式">
            <el-select v-model="formData.parentId" style="width: 100%" filterable clearable>
              <el-option v-for="item in materialStyles" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <p v-if="!formData.parentId" style="font-size: 12px; color: orange">无上级样式无需选择</p>
          </ElFormItem>
        </template>
        <template #label-name>
          <span>素材样式名称</span>
        </template>
      </MaterialStyleForm>

      <tag-set v-else ref="tagFormRef" :form-type="modalType" :group-list="gameGroups" :game-list="gamesList" />

      <template #footer>
        <div class="m-foot">
          <el-button @click="onCloseModal">取消</el-button>
          <el-button type="primary" :loading="onConfirmLoading" @click="onTagFormConfirm(selectionList)"> 确认 </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 选择素材关联 -->
    <pick-material
      v-model="pickModel"
      :selection="relationMaterialInfo"
      :label-type="labelType"
      :row-label-id="relatedMaterialLabelId"
      multiline
      @on-select="pickMaterialSelect"
    >
      <template #tag-select="{ queryForm, qureyAction }">
        <el-form-item :label="tagType.label">
          <el-cascader
            v-if="pageType.imageStyle"
            v-model="queryForm.imageStyles"
            clearable
            filterable
            collapse-tags
            style="width: 180px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="materialStyleTree"
          >
          </el-cascader>
          <el-select
            v-else
            v-model="queryForm.labelId"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
            style="width: 180px"
            :multiple-limit="10"
            :popper-append-to-body="false"
            @change="qureyAction"
          >
            <el-option v-for="label in tagType.list" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </el-form-item>
      </template>
    </pick-material>
  </div>
</template>
<script setup>
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import { Message } from 'element-ui'
import { setLocal, getLocal, div } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { getTag } from '@/api/manage.model'
import { getTagsMaterial, modifyTagsMaterial } from '@/api/material.model'
import PickMaterial from '@/components/material/material.vue'
import QueryForm from './components/tags/query-form.vue'
import TagTable from './components/tag-table.vue'
import TagSet from './components/tag-set.vue'
import MaterialStyleForm from './components/tags/tag-form.vue'
import LevelToggleBtn from './components/tags/level-toggle-btn.vue'
import defaultCols, { imageStyleCols } from '../data/tag_column'
import { initPageData, GAME_GROUPS, GAMES, SYS_TAGS, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
import { LABEL_TYPES, LEVEL_TYPES, FORM_TYPE } from './const'
import { useTable, useAddUpdateModal, useTableView } from './hooks/useTags.js'

const route = useRoute()
const router = useRouter()
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, SYS_TAGS, IMAGE_STYLE_TAG_TREE])
const sysTags = computed(PAGE_REQUIRED_OPTS.SYS_TAGS)
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const gamesList = computed(PAGE_REQUIRED_OPTS.GAMES)
const materialStyleTree = computed(PAGE_REQUIRED_OPTS.IMAGE_STYLE_TAG_TREE)

const materialStyles = computed(() =>
  sysTags.value.filter((item) => item.labelType === LABEL_TYPES.MATERIAL_STYLE_LABEL).filter((item) => item.level === LEVEL_TYPES.LEVEL_ONE)
)

// State
const relatedMaterialLabelId = ref(null)
let relatedMaterialLabelIdValueForSubmitReq = null
const pickModel = ref(false)
const relationMaterialInfo = ref([])

// Computed
const pageType = computed(() => {
  return {
    contentTag: route.name === 'tagsindex',
    threeD: route.name === 'tags3dvideosource',
    imageStyle: route.name === 'tagsstyles'
  }
})
const labelType = computed(() => {
  if (pageType.value.contentTag) return LABEL_TYPES.CONTENT_LABEL
  if (pageType.value.threeD) return LABEL_TYPES.THREED_LABEL
  if (pageType.value.imageStyle) return LABEL_TYPES.MATERIAL_STYLE_LABEL
})

const queryFormRef = ref(null)
const viewPortRef = ref(false)

const { viewType, onToggleViewType } = useTableView()
const {
  tableData,
  tagTreeData,
  tableLoading,
  tableHeight,
  tagTreeTableRef,
  pager,
  selectionList,
  getTreeData,
  onToggleRowExpansion,
  onQueryAction,
  getTableData,
  onTableSelectionChange,
  onTableRowRemove
} = useTable(queryFormRef, labelType, viewType)

const { modalType, showTagFormModal, tagFormRef, onConfirmLoading, onShowAddTagModal, onBatchModify, onCloseModal, onTagFormConfirm } =
  useAddUpdateModal({ getTableData, getTreeData, labelType })

const onTableRowUpdate = (row) => {
  modalType.value = FORM_TYPE.UPDATE
  getTag({ labelId: row.labelId }).then((data) => {
    if (data) {
      const { labelId, content, gameIds, parentId, level } = data
      const games = isEmpty(gameIds) ? [] : gameIds.split(',').map((e) => Number(e))
      showTagFormModal.value = true
      const imageStyleForm = {
        labelId,
        parentId,
        level,
        label: content,
        gameIds: games,
        gameGroupId: ''
      }

      nextTick(() => {
        tagFormRef.value.setForm(pageType.value.imageStyle ? imageStyleForm : { labelId, content, game: games })
      })
    }
  })
}

const modalTitle = computed(() => {
  if (modalType.value === FORM_TYPE.BATCH) return '批量修改游戏'
  return `${modalType.value === FORM_TYPE.UPDATE ? '修改' : '新增'}${tagType.value.label}`
})

// Material Logic
const videoSourceData = computed(() => {
  return sysTags.value.filter((item) => {
    return item.labelType === LABEL_TYPES.THREED_LABEL
  })
})

const labelData = computed(() => {
  return sysTags.value.filter((item) => {
    return item.labelType === LABEL_TYPES.CONTENT_LABEL
  })
})

const tagType = computed(() => {
  const type = {
    label: '',
    list: []
  }

  if (pageType.value.contentTag) {
    type.label = '内容标签'
    type.list = labelData.value
  }
  if (pageType.value.threeD) {
    type.label = '3D视频源标签'
    type.list = videoSourceData.value
  }

  if (pageType.value.imageStyle) {
    type.label = '素材样式'
    type.list = []
  }

  return type
})

const toggleViewType = () => {
  onToggleViewType()
  nextTick(() => {
    onQueryAction()
    viewPortRef.value.calcHeight()
  })
}

const getRelated = (row) => {
  if (!(row && row.labelId)) return
  const { parentId, labelId: rowLabelId } = row
  relatedMaterialLabelIdValueForSubmitReq = rowLabelId

  if (pageType.value.imageStyle) {
    // 如果是二级素材样式，parentId会存在，构建一个级联的数据结构用于modal回显查询参数
    if (parentId) {
      relatedMaterialLabelId.value = [[parentId, rowLabelId]]
    } else {
      // 如果是一级素材样式，parentId不存在，构建一个级联的数组（包含一级素材样式下面所有的二级素材样式），用于modal回显查询参数
      const parentItem = materialStyleTree.value.find((i) => i.labelId === rowLabelId)
      relatedMaterialLabelId.value = []
      if (parentItem?.children?.length) {
        relatedMaterialLabelId.value = parentItem.children.map((c) => [rowLabelId, c.labelId])
      }
    }
  } else {
    // 3d视频源和内容标签传入id，兼容之前或别的（媒体素材标签）传参逻辑
    relatedMaterialLabelId.value = rowLabelId
  }

  getTagsMaterial({ labelId: row.labelId })
    .then((data) => {
      if (isArray(data)) {
        relationMaterialInfo.value = data
        pickModel.value = true
      }
    })
    .catch((err) => {
      Message.error({
        duration: 5000,
        message: err
      })
    })
}

const toMaterialPageList = (row) => {
  const query = {}
  if (pageType.value.contentTag) {
    query.labelId = JSON.stringify([row.labelId])
  } else if (pageType.value.imageStyle) {
    const imageStyleCascaderValue = row.level === 1 ? [row.labelId] : [row.parentId, row.labelId]
    query.styleId = JSON.stringify(imageStyleCascaderValue)
  } else {
    query.videoLabelId = JSON.stringify([row.labelId])
  }
  router.push({
    name: 'reportMaterialAnalysis',
    query
  })
}

const pickMaterialSelect = (items) => {
  if (isArray(items)) {
    modifyTagsMaterial({
      labelId: relatedMaterialLabelIdValueForSubmitReq,
      imageIds: items.map((ret) => ret.imageId)
    }).then((data) => {
      if (data) {
        pickModel.value = false
        getTableData()
      }
    })
  }
}

// Initialization
// Restore page size from local storage
const localPageSize = parseInt(getLocal('DOCUMENT_PAGESIZE'))
if (localPageSize) pager.value.pageSize = localPageSize
else pager.value.pageSize = 20

// Watch page size change to save local
watch(
  () => pager.value.pageSize,
  (newSize) => {
    setLocal('DOCUMENT_PAGESIZE', newSize)
  }
)

onMounted(() => {
  const { contentTag, threeD, imageStyle } = pageType.value
  // 由于Tag.vue是复用的路由，离开当前路由会导致又创建了一个新的 Tags.vue 实例 ，新实例在挂载时触发了 onMounted
  // 进行一个判断，只有在 contentTag || threeD || imageStyle 时才进行查询和树形数据获取
  if (contentTag || threeD || imageStyle) {
    onQueryAction()
    getTreeData()
  }
})
</script>
<style lang="scss" scoped>
.pager {
  padding: 5px 0;
  text-align: right;
}
</style>
